module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"òweyorùbá.com - Yoruba Proverbs","short_name":"òweyorùbá","description":"Largest online collection of Yorùbá Proverbs","start_url":"/","background_color":"#ffffff","theme_color":"#e59a05","display":"standalone","icon":"static/favicon.png","icons":[{"src":"static/favicon.png","sizes":"16x16","type":"image/png"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"7e839a3b7ed418a8202e94a489802294"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
